export const TestElementStatuses = [
	{ label: 'Non validé', value: 'failed', color: '#FF3D62' },
	{ label: 'Validé', value: 'validated', color: '#8BEA67' },
	{ label: 'En cours', value: 'pending', color: '#D4DCE5' }
]



// WEBPACK FOOTER //
// ./src/config/enum/TestElementStatuses.js